module.exports = __webpack_public_path__ + "static/media/analysis-macrovector-01 4.87feee57.png";